import { useParams } from "react-router-dom";
import { useIndustries } from "../../hooks/queries/useIndustries";
import Products from "../Products";
import { useAppContext } from "../../contexts/AppContext";

const SearchResult = () => {
  const params = useParams<{
    term?: string;
    industry?: string;
    mixIdeal?: string;
  }>();

  const { data: industries = [] } = useIndustries();
  const { isCampanhaSolar } = useAppContext();

  let title = "Resultado de pesquisa para ";

  if (params.term && params.term !== "*") {
    title = `${title} '${params.term}'`;
  } else {
    title = `${title} todos os produtos`;
  }

  if (params.industry && params.industry !== "*") {
    const name = industries.find(
      item => String(item.cd_fornecedor) === params.industry
    );

    const nameStr = name ? name.ds_fornecedor : "...";

    title = `${title} no laboratório '${nameStr}'`;
  } else {
    title = `${title} de todos os laboratórios`;
  }

  if (isCampanhaSolar) {
    title = `${title} na campanha Solar`;
  }

  if (params.mixIdeal && params.mixIdeal !== "*") {
    const name = industries.find(
      item => String(item.cd_fornecedor) === params.mixIdeal
    );

    const nameStr = name ? name.ds_fornecedor : "...";

    title = `Resultado de pesquisa do mix ideal do laboratório '${nameStr}'`;
  }

  return <Products params={params} title={title} />;
};

export default SearchResult;
